import {IOfferListRouteParams, IOfferListRouteQuery, IOfferListUrlParseResult} from "./types/IOfferListUrlStrategy";
import {getOfferListUrlStrategy} from "./get_offer_list_url_strategy";

export const parseOfferListUrl = (params: IOfferListRouteParams, routeQuery: IOfferListRouteQuery = {}): IOfferListUrlParseResult =>
    getOfferListUrlStrategy().parse(params, routeQuery);

/** Parses a listing route from its slug params, the requested pathname and the raw query string without its leading "?" (see `readOfferListSearch`). */
export const parseOfferListRoute = (
    params: Pick<IOfferListRouteParams, "friendlySlug" | "offerListSubFilter" | "country" | "abroadRegionSlug">,
    request: {pathname: string; search: string},
    routeQuery: IOfferListRouteQuery
): IOfferListUrlParseResult =>
    parseOfferListUrl(
        {
            friendlySlug: params.friendlySlug,
            offerListSubFilter: params.offerListSubFilter,
            country: params.country,
            abroadRegionSlug: params.abroadRegionSlug,
            pathname: request.pathname,
            search: request.search
        },
        routeQuery
    );

/** A gone address (410) or one that redirects to its canonical form; the route fetcher answers those, nothing parses them further. */
export const isOfferListAddressRedirected = (result: IOfferListUrlParseResult): boolean =>
    result.status === "gone" || (result.status === "ok" && Boolean(result.canonicalUrl));

export const readOfferListSearch = (url: string): string => {
    const queryIndex = url.indexOf("?");

    if (queryIndex === -1) {
        return "";
    }

    return url.slice(queryIndex + 1).split("#")[0];
};
import {IOfferListRouteParams, IOfferListRouteQuery, IOfferListUrlParseResult} from "./types/IOfferListUrlStrategy";
import {getOfferListUrlStrategy} from "./get_offer_list_url_strategy";

export const parseOfferListUrl = (params: IOfferListRouteParams, routeQuery: IOfferListRouteQuery = {}): IOfferListUrlParseResult =>
    getOfferListUrlStrategy().parse(params, routeQuery);

/** Parses a listing route from its slug params, the requested pathname and the raw query string without its leading "?" (see `readOfferListSearch`). */
export const parseOfferListRoute = (
    params: Pick<IOfferListRouteParams, "friendlySlug" | "offerListSubFilter" | "country" | "abroadRegionSlug">,
    request: {pathname: string; search: string},
    routeQuery: IOfferListRouteQuery
): IOfferListUrlParseResult =>
    parseOfferListUrl(
        {
            friendlySlug: params.friendlySlug,
            offerListSubFilter: params.offerListSubFilter,
            country: params.country,
            abroadRegionSlug: params.abroadRegionSlug,
            pathname: request.pathname,
            search: request.search
        },
        routeQuery
    );

/** A gone address (410) or one that redirects to its canonical form; the route fetcher answers those, nothing parses them further. */
export const isOfferListAddressRedirected = (result: IOfferListUrlParseResult): boolean =>
    result.status === "gone" || (result.status === "ok" && Boolean(result.canonicalUrl));

export const readOfferListSearch = (url: string): string => {
    const queryIndex = url.indexOf("?");

    if (queryIndex === -1) {
        return "";
    }

    return url.slice(queryIndex + 1).split("#")[0];
};
